module.exports = __webpack_public_path__ + "media/icon-page-view.aa8465ba.svg";